import classNames from "classnames";
import { get, isEmpty } from "lodash";
import { Select } from "PFComponents/select/select";
import React, { useMemo, useState } from "react";
import { Controller, ErrorOption, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PropertyFieldProps } from "../property";
import css from "./properties_fields.module.scss";

const STANDARD_FIELD_WIDTH = 145;
const getFieldWidth = (fieldName: string) => {
  if (fieldName.includes("children") && fieldName.includes("target")) {
    return 400;
  } else {
    return STANDARD_FIELD_WIDTH;
  }
};

export const SelectOneField = ({
  fieldName,
  label,
  options,
  required,
  disabled,
  validate,
  className
}: PropertyFieldProps) => {
  const {
    control,
    formState: { errors },
    watch
  } = useFormContext();

  const { t } = useTranslation("saasAdmin");
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState("");

  const value = watch(fieldName);

  const selectOptions = useMemo(
    () =>
      (options || []).map((option) => ({
        id: option,
        item: option,
        displayElement: option
      })),
    [options]
  );

  const handleSearch = (newValue: string) => {
    setSearch(newValue);
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      disabled={isEmpty(value)}
      rules={{
        required: required && t("filtersConfig.errors.required"),
        validate: (value) => validate?.(value) || true
      }}
      render={({ field }) => {
        const options = selectOptions.filter(
          ({ displayElement }) =>
            !search || displayElement?.includes(search) || search.includes(displayElement)
        );

        return (
          <Select
            // @ts-ignore
            label={label}
            kind="bordered"
            value={isOpen ? search : field.value}
            controlledValue
            options={options}
            error={(get(errors, field.name) as unknown as ErrorOption)?.message}
            handleChange={(newValue: string) => {
              field.onChange(newValue === field.value ? undefined : newValue);
              setSearch("");
            }}
            required={required}
            rootClassName={classNames(css.selectField, className)}
            disabled={disabled}
            handleInputChange={handleSearch}
            handleDropDownToggle={setIsOpen}
            style={{ width: getFieldWidth(field.name) }}
          />
        );
      }}
    />
  );
};
